export const absoluteTopImpressionRate = {
  name: 'AbsoluteTopImpressionRatePercent',
  title: 'ColumnName_AbsoluteTopImpressionRate',
  property: 'AbsoluteTopImpressionRatePercent',
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopImpressionRate',
};


export const topImpressionRate = {
  name: 'TopImpressionRatePercent',
  title: 'ColumnName_TopImpressionRate',
  property: 'TopImpressionRatePercent',
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  helpId: 'pop_BA_Reporting_Clarity_TopImpressionRate',
};

export const absoluteTopImpressionRateLabel = {
  name: 'AbsoluteTopImpressionRate',
  title: 'ColumnName_AbsoluteTopImpressionRate',
  property: 'AbsoluteTopImpressionRate',
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopImpressionRate',
};


export const topImpressionRateLabel = {
  name: 'TopImpressionRate',
  title: 'ColumnName_TopImpressionRate',
  property: 'TopImpressionRate',
  sortable: true,
  type: 'number',
  format: 'percentage-value',
  helpId: 'pop_BA_Reporting_Clarity_TopImpressionRate',
};
